import { useMutation } from 'react-query';
import { IPractitionerRegistrationData, PractitionerRegistrations } from '../../services/PractitionerRegistration';

export const useCreatePractitionerRegistration = () =>
  useMutation((params: IPractitionerRegistrationData) =>
    PractitionerRegistrations.createPractitionerRegistration(params)
  );
